<template>
  <div class="default">
    <div class="leftMenu">
      <Menu></Menu>
    </div>
    <div class="main" id="main" ref="main">
      <div class="top">
        <topHeader
          :showTab="showTab"
          :canAreaFilterShow="canAreaFilterShow"
        ></topHeader>
      </div>
      <div class="main-content" :style="paddingTop" ref="mainContent">
        <div class="cont-wrapper" :style="fullHeight">
          <router-view :key="key"></router-view>
          <i class="iconfont icon-huidaodingbu toTop" @click="scrollTop"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/components/common/Menu' // 左侧导航组件
import topHeader from '@/components/common/topHeader'
import { debounce } from 'lodash'

export default {
  name: 'layout',
  data: function() {
    return {
      topHeight: 60,
      // 是否展示tab切换项 向上滚动的时候 自动隐藏tabs
      showTab: true,

      canAreaFilterShow: 'show',
    }
  },
  components: {
    Menu,
    topHeader,
  },
  computed: {
    key() {
      return this.$route.fullPath
    },
    fullHeight() {
      if (this.$route.name === 'staff-unit') {
        return 'height: 100%;padding-left: 0;padding-top: 0'
      } else {
        return ''
      }
    },
    paddingTop() {
      // console.log(this.$route.name)
      if (this.hiddenAreaFilterPages.includes(this.$route.name)) {
        this.canAreaFilterShow = 'hidden'
        return `padding-top: 70px`
      } else {
        this.canAreaFilterShow = 'show'
        return `padding-top: ${this.topHeight}px`
      }
    },
    hiddenAreaFilterPages() {
      return ['staff', 'staff-unit', 'role', 'companyHouseStatus', 'companyOvernightRentalRate', 'companyLease', 'companySigned', 'jx-export', 'online-export']
    }
  },
  created() {
    this.hackReset = true
    this.$store.dispatch('getRole', { id: this.$store.state.currentUser.uid })

  },
  mounted() {
    let that = this
    this.$root.bus.$on('topHeight', function(top) {
      that.topHeight = top
    })
    // 添加main的滚动监听  还需要判断排除掉其他内部div的滚动导致的情况
    this.$refs.main.addEventListener(
      'scroll',
      debounce(function(event) {
        if (event.target.id === 'main') {
          that.showTab = event.target.scrollTop <= 20
        }
      }, 10),
      true
    )
  },
  beforeDestroy() {
    this.$refs.main.removeEventListener('scroll', debounce.cancel, true)
  },

  methods: {
    // 滚动到顶部
    scrollTop() {
      this.showTab = true
      this.$refs.main.scrollTo(0, 0)
    },
  },
}
</script>
<style scoped lang="scss">
body,
html {
  height: 100%;
  position: relative;
}
.default {
  background: rgba(240, 240, 240, 1);
  position: absolute;
  height: 100%;
  width: 100%;
}
.main {
  margin-left: 200px;
  height: 100%;
  overflow: auto;
}
.leftMenu {
  float: left;
  width: 200px;
  height: 100%;
  z-index: 999;
  overflow: auto;
}
.main-content {
  height: 100%;
  .cont-wrapper {
    padding: 20px 40px;
    .toTop {
      position: absolute;
      right: 5px;
      bottom: 40px;
      font-size: 30px;
      color: #999;
      cursor: pointer;
    }
    //  overflow-y: scroll;
  }
}
</style>

<style>
.main-right-search, .list-contain {
  background: white;
}

.main-right-search {
  min-height: 60px;
  padding: 8px;
  -webkit-box-shadow: 0px 2px 2px 0px #ccc;
  box-shadow: 0px 2px 2px 0px #ccc;
}
</style>



// WEBPACK FOOTER //
// src/page/layout.vue